import { IconAlertTriangle } from '@tabler/icons-react'
import styled from 'styled-components'

export const IconAlert = styled(IconAlertTriangle)`
	color: ${({ theme }) => theme.color.textContrast};
	flex: 0 0 auto;
`
